import styled from "styled-components";

export const StyledPlaces = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledPlacesContent = styled.div`
    padding: 40px;
    height: 100%;
`;